module.exports = __webpack_public_path__ + "img/videoImg.909a7502.png";